/**
 * Fix add-to-cart loader showing on wrong button
 * Issue: When clicking ATC on product cards, loader shows on first button instead of clicked button
 */
(function() {
  let clickedButton = null;

  // Capture which button was clicked
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (btn) {
      clickedButton = btn;

      // Remove loading from all other buttons
      document.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
        if (button !== btn) {
          button.classList.remove('loading');
        }
      });
    }
  }, true);

  // Remove loading state when cart is opened/updated
  document.addEventListener('cart:item-added', function() {
    if (clickedButton) {
      clickedButton.classList.remove('loading');
      clickedButton = null;
    }
  });

  document.addEventListener('quick-cart:open', function() {
    if (clickedButton) {
      clickedButton.classList.remove('loading');
      clickedButton = null;
    }
  });

  // Intercept when loading class is added and redirect to correct button
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;

        // If loading was added to wrong button and we know the right one
        if (target.classList.contains('loading') &&
            target.hasAttribute('data-add-to-cart') &&
            clickedButton &&
            target !== clickedButton) {

          // Remove from wrong button
          target.classList.remove('loading');

          // Add to correct button
          clickedButton.classList.add('loading');
        }
      }
    });
  });

  // Observe all current and future add-to-cart buttons
  const observeButtons = function() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      observer.observe(btn, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  };

  // Initial observation
  observeButtons();

  // Re-observe when new content is added (for quick view, etc)
  const contentObserver = new MutationObserver(observeButtons);
  contentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
